<template>
	<div class="view-box">
		<div class="container">
			<div class="form-item-label">当前初始视角</div>

			<!-- 初始视角截图 -->
			<div ref="canvasBox" class="canvas-box"></div>

      <div class="scroll-view">


			<!-- 当前视角方向 -->
			<div v-if="false" class="form-item-box">
				<div class="form-item-label">视角方向</div>
				<div class="compass-box">
					<div class="compass">
						<img class="viewer" src="@/assets/images/compass-viewer.png" /> <img class="shadow" src="@/assets/images/compass-shadow.png" />
						<div class="label label-east">东</div>
						<div class="label label-south">南</div>
						<div class="label label-east">西</div>
						<div class="label label-north">北</div>
					</div>
				</div>
			</div>

      <div class="form-item-box">
        <div class="form-item-label">视角方向<span class="v-font-12 v-color-red">(旋转水平视角至正北方向然后保存)</span></div>
        <div class="v-mt-10 v-mb-20">
          <span class="v-mr-10">当前正北方向：{{dir === '' ? '未设置' : dir}}</span>
          <el-button size="mini" type="primary" @click="setDir">设置方向</el-button>
          <el-button size="mini" type="gray" @click="dir = ''">重置</el-button>
        </div>
      </div>

			<!-- fov-景深 -->
			<div class="form-item-box">
				<div class="form-item-label">视角（FOV）范围设置</div>
				<div class="slider-box">
					<vue-slider v-model="fov" class="vue-slider-custom" :min="0" :max="180" :enable-cross="false" @change="handleSliderChange" />
					<div class="slider-value-box">
						<div class="slider-value">
							<input v-model="fov[0]" class="input" type="text" />
							<div class="label">最近</div>
						</div>
						<div class="slider-value">
							<input v-model="fov[1]" class="input" type="text" />
							<div class="label">初始</div>
						</div>
						<div class="slider-value">
							<input v-model="fov[2]" class="input" type="text" />
							<div class="label">最远</div>
						</div>
					</div>
				</div>
			</div>

			<!-- vlookat-垂直 -->
			<div class="form-item-box">
				<div class="form-item-label">垂直视角限制</div>
				<div class="slider-box">
					<vue-slider v-model="vlookat" class="vue-slider-custom" :min="-90" :max="90" :enable-cross="false" @change="handleSliderChange" />
					<div class="slider-value-box">
						<div class="slider-value">
							<input v-model="vlookat[0]" class="input" type="text" />
							<div class="label">最高</div>
						</div>
						<div class="slider-value">
							<input v-model="vlookat[1]" class="input" type="text" />
							<div class="label">初始</div>
						</div>
						<div class="slider-value">
							<input v-model="vlookat[2]" class="input" type="text" />
							<div class="label">最低</div>
						</div>
					</div>
				</div>
			</div>

			<!-- hlookat-水平 -->
			<div class="form-item-box">
				<div class="form-item-label">水平视角限制</div>
				<div class="slider-box">
					<vue-slider v-model="hlookat" class="vue-slider-custom" :min="-180" :max="180" :enable-cross="false" @change="handleSliderChange" />
					<div class="slider-value-box">
						<div class="slider-value">
							<input v-model="hlookat[0]" class="input" type="text" />
							<div class="label">最左</div>
						</div>
						<div class="slider-value">
							<input v-model="hlookat[1]" class="input" type="text" />
							<div class="label">初始</div>
						</div>
						<div class="slider-value">
							<input v-model="hlookat[2]" class="input" type="text" />
							<div class="label">最右</div>
						</div>
					</div>
				</div>
			</div>
		</div>

    </div>

		<div class="view-box-rect">
			<div class="angle angle-top"></div>
			<div class="angle angle-bottom"></div>
			<div class="angle angle-left"></div>
			<div class="angle angle-right"></div>
			<div v-loading="doSubmitLoading" class="angle-save-btn" @click="cutCurrentView">
				保存当前视野
			</div>
		</div>

		<div class="panel-footer">
			<div v-loading="doSubmitLoading" class="btn btn-save" @click="doSubmit">
				保存
			</div>
			<div v-if="groupList && groupList.length > 1 && groupList[groupList.length-1].id != activeGroupId" class="btn btn-compare" @click="showCompare">对比</div>
			<div class="btn btn-cancel" @click="mutationUpdateIsShowViwer(false)">取消</div>
		</div>
	</div>
</template>

<script>
	import {mapState, mapActions, mapMutations} from "vuex";
	import VueSlider from "vue-slider-component";
	import "vue-slider-component/theme/default.css";

	export default {
		components: {VueSlider},

		data() {
			return {
				vlookat: [-90, 90, 90],
				hlookat: [-180, 0, 180],
				fov: [30, 95, 140],
				doSubmitLoading: false,
				isChangeView: false,
				isChangeViewTimer: 0,
        dir:''
			};
		},

		computed: {
			...mapState("tour", ["materialId", "sceneDetail", "krp", "groupList", "activeGroupId"])
		},

		created() {
			window.krpjs.getshotCanvas = this.getshotCanvas;
			// window.krpjs.onviewchanged = this.onViewChanged;
			this.initViewer()
		},

		methods: {

			...mapActions("tour", {
				actionGetSceneDetail: "getSceneDetail",
				actionShowCompareView: "showCompareView",
			}),

			...mapMutations('tour', {
				mutationUpdateIsShowViwer: "UPDATE_IS_SHOW_VIWER"
			}),

			showCompare() {
				this.actionShowCompareView();
			},

			closeDialog() {
				this.$emit('update:show', false);
				window.krpjs.getshotCanvas = null;
				window.krpjs.onviewchanged = null;
			},

			initViewer() {
				let info = this.sceneDetail.info || {};
				this.fov = info.fov || this.fov;
				this.hlookat = info.hlookat || this.hlookat;
				this.vlookat = info.vlookat || this.vlookat;
				this.krp.set("view.vlookat", this.vlookat[1] || 90);
				this.krp.set("view.hlookat", this.hlookat[1] || 0);
				this.krp.set("view.fov", this.fov[1] || 95);
				this.dir = !isNaN(info.dir) ? info.dir : '';
				setTimeout(() => {
					this.krp.call("makescreenshot()");
				}, 500);
			},

			onViewChanged() {
				this.isChangeView = true;
				let view = this.krp.get("view");
				let hlookat = view.hlookat% 360;
				hlookat = hlookat > 180 ? -360 + hlookat : hlookat;
				hlookat = hlookat < -180 ? 360 + hlookat : hlookat;
				this.fov = [view.fovmin, view.fov.toFixed(2), view.fovmax];
				this.hlookat = [view.hlookatmin, hlookat.toFixed(2), view.hlookatmax];
				this.vlookat = [view.vlookatmin, view.vlookat.toFixed(2), view.vlookatmax];
				clearTimeout(this.isChangeViewTimer)
				this.isChangeViewTimer = setTimeout(() => {
					this.isChangeView = false;
				}, 500);
			},

      setDir(){
				let hlookat = this.krp.get('view').hlookat% 360;
				hlookat = hlookat > 180 ? -360 + hlookat : hlookat;
				hlookat = hlookat < -180 ? 360 + hlookat : hlookat;
				this.dir = hlookat.toFixed(2);
      },

			handleSliderChange() {
				if (this.isChangeView) {
					return
				}
				this.krp.set("view.fovmin", this.fov[0]);
				this.krp.set("view.fov", this.fov[1]);
				this.krp.set("view.fovmax", this.fov[2]);
				this.krp.set("view.hlookatmin", this.hlookat[0]);
				this.krp.set("view.hlookat", this.hlookat[1]);
				this.krp.set("view.hlookatmax", this.hlookat[2]);
				this.krp.set("view.vlookatmin", this.vlookat[0]);
				this.krp.set("view.vlookat", this.vlookat[1]);
				this.krp.set("view.vlookatmax", this.vlookat[2]);
			},

			getshotCanvas(canvas) {
				this.$refs.canvasBox.innerHTML = "";
				this.$refs.canvasBox.appendChild(canvas);
			},

			//截取保存当球按截屏
			cutCurrentView() {
				this.onViewChanged()
				// this.krp.call(`adjusthlookat(0);`);
				// this.vlookat[1] = parseInt(this.krp.get("view.vlookat"));
				// this.hlookat[1] = parseInt(this.krp.get("view.hlookat"));
				// this.fov[1] = parseInt(this.krp.get("view.fov"));
				this.krp.call("makescreenshot()");
				this.doSubmit();
			},

			async doSubmit() {
				this.doSubmitLoading = true;
				try {

					await this.api.material.editMaterialInfo({
						id: this.materialId,
						info: {
							vlookat: this.vlookat,
							hlookat: this.hlookat,
							fov: this.fov,
              dir:this.dir
						}
					});
					await this.actionGetSceneDetail({materialId: this.materialId});
					this.$message.success("保存成功");
				} catch (e) {
					console.error(e);
				}

				this.doSubmitLoading = false;
			}
		}
	};
</script>

<style scoped lang="scss">
	.form-item-label {
		padding: 5px 0;
	}

	.canvas-box {
		width: 300px;
		height: 150px;
		border: 1px solid #929292;
		padding: 5px;
	}

	.view-box {
		color: #fff;
		position: absolute;
		top: 60px;
		right: 20px;
		background: rgba(0, 0, 0, 0.6);
		border-radius: 4px;
		width: 350px;
	}

	.container {
		padding: 10px;
	}

	.slider-box {
		padding: 10px 20px;
	}

	.view-box-rect {
		position: fixed;
		transform-origin: center center;
		opacity: 0;
		animation: showreact 0.3s ease 0.5s;
		animation-fill-mode: forwards;
		background: red;
		left: 50%;
		top: 50%;
	}

	.view-box-rect .angle-top,
	.view-box-rect .angle-bottom {
		height: 4px;
		width: 400px;
		position: absolute;
		background: #fff;
		left: 50%;
		transform: translateX(-50%);
	}

	.view-box-rect .angle-left,
	.view-box-rect .angle-right {
		width: 4px;
		height: 200px;
		position: absolute;
		background: #fff;
		top: 50%;
		transform: translateY(-50%);
	}

	.view-box-rect .angle-top {
		top: -100px;
	}

	.view-box-rect .angle-bottom {
		bottom: -100px;
	}

	.view-box-rect .angle-left {
		left: -200px;
	}

	.view-box-rect .angle-right {
		right: -200px;
	}

	.view-box-rect .angle-save-btn {
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
		white-space: nowrap;
		background: rgba(255, 255, 255, 0.8);
		padding: 1px 10px;
		border-radius: 4px;
		color: #666;
		cursor: pointer;
	}

	@keyframes showreact {
		from {
			opacity: 0;
			transform: scale(0);
		}
		to {
			opacity: 1;
			transform: scale(1);
		}
	}

	.control-box {
		padding-top: 30px;
	}

	.panel-footer {
		display: flex;
	}

	.panel-footer .btn {
		flex: 1;
		height: 40px;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;

		&:hover {
			opacity: 0.8;
		}
	}

	.panel-footer .btn-save {
		background: #006ab1;
	}

	.panel-footer .btn-cancel {
		background: #9e9e9e;
	}

	.panel-footer .btn-compare {
		background: #E6A23C;
	}

	.fov-control-box {
		padding: 30px;
	}

	.fov-control-label {
		margin-right: 20px;
	}

	.fov-control {
		flex: 1;
	}

	.vue-slider-custom ::v-deep {
		.vue-slider-dot-handle {
			width: 8px;
			height: 19px;
			border-radius: 0;
			border: 0;
			box-shadow: none;
			margin-top: 2px;
			background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAmCAQAAABn2dNaAAABTElEQVQ4y92SPU7DQBCFFxAgUSEaFImGghKJgh46JA5Al4YTUCIqTpAa0XMAagQNDQ0SB8AQfgKJIRDHa2wI8WNnbE8s/6Vnnp41s+/zem1ZuaiWGgvouuuWhdr3dpVSwYq+LgQsvaaiwoxu6DATn2Jepcvbdm3Z+lfvY0Jly6vpc47b7qYqLkx6B/rCq6n/XtjBYVW8Cg9DbJXFC7BA9YHlongKZzC3Dwm5wVweaJggDBBEyEk2rkfxl5FvOjPtpeN1Wv02J9Rsn/YYYCOJF/EE/PCf0Gf3DWyqgyWKp3FJuMOBwyYNCLnCrMKReWTYQw+fKdHMhz1WdHXMq+fl8Edh4B1ddjfuklmAN9hsO+4SCdApkQBtvLJHilYEeBG12K24E+C5RAI8mk9JzkqAh5yabAHuzUBuxl0iASzcsUeKVlLALTsrAapqLPAHWFcFmw1dQZcAAAAASUVORK5CYII=");
			background-size: cover;
		}
	}

	.slider-value-box {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-top: 20px;

		.slider-value {
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			font-size: 12px;
		}

		.slider-value .input {
			width: 40px;
			background: rgba(0, 0, 0, 0.3);
			border: 1px solid #929292;
			color: #fff;
			font-size: 12px;
			text-align: center;
		}

		.slider-value .label {
			margin-top: 5px;
		}
	}

	.form-item-box {
		border-bottom: 1px solid #929292;
		margin-top: 10px;
	}

	::v-deep .vue-slider-rail .vue-slider-dot:nth-child(3) {
		z-index: 6 !important;
	}

	.compass-box {
		padding: 30px 0;

		.compass {
			border-radius: 100%;
			border: 1px solid #fff;
			width: 150px;
			height: 150px;
			margin: 0 auto;
			position: relative;
		}

		.viewer {
			position: absolute;
			left: 50%;
			top: 50%;
			transform: translate(-50%, -50%);
			width: 20px;
			z-index: 1;
		}

		.shadow {
			position: absolute;
			left: 50%;
			top: 50%;
			width: 86px;
			transform: translate(-50%, -100%);
			margin-top: -8px;
			cursor: pointer;
			-webkit-user-drag: none;
		}

		.label {
			font-size: 12px;
			color: #fff;
			position: absolute;
		}

		.label-north {
			top: -25px;
			left: 50%;
			transform: translateX(-50%);
		}

		.label-south {
			bottom: -25px;
			left: 50%;
			transform: translateX(-50%);
		}
	}

  .scroll-view{
    max-height: 400px;
    overflow-y: auto;
    overflow-x: hidden;
  }
</style>
